import {MerchantOfRecord} from '@vio/core/src/api-types/bovio/response/booking'

/**
 * Compute merchantOfRecordCode, which is a short form of merchantOfRecord value available with BoFH
 *
 * @param merchantOfRecord - merchantOfRecord value, e.g. "expedia"
 * @param providerCode - Provider code, e.g. "EPS"
 * @returns Merchant of record code
 */
export const getMerchantOfRecordCode = (
  merchantOfRecord: string | undefined | null,
  providerCode: string | undefined | null
) => {
  if (merchantOfRecord === MerchantOfRecord.Findhotel) {
    return 'FHT'
  }

  if (merchantOfRecord === MerchantOfRecord.Hotel) {
    return 'Hotel'
  }

  return providerCode || ''
}
